import { logError } from 'client/javascript/util/logger';
import setupWeGlideAtBreakpoints from 'client/javascript/we_glide/we_glide_at_breakpoints';
import { settings as raySettings } from '@wework/ray-core';
import { trackAnalyticsInteractionByLink } from 'client/javascript/analytics';
import { setupCardArticleIdeasAnalytics } from 'client/javascript/pages/shared/sections/card_article_ideas';
import {
  setupCardArticleNewsroomAnalytics,
  CARD_ARTICLE_NEWSROOM_CLASS
} from 'client/javascript/pages/shared/sections/card_article_newsroom';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';

export const SELECTORS = {
  MODULE: '.cards-articles-banner',
  SLIDER_TRACK: '.cards-articles-banner [data-glide-el="track"]',
  MODULE_LINK: '.cards-articles-banner__link',
  CARD_ARTICLE_IDEAS: '.card-article-ideas',
  CARD_ARTICLE_NEWSROOM: '.card-article-newsroom'
};

export const MODULE_NAME = 'Cards/Articles Banner';

const WE_GLIDE_OPTIONS = {
  perView: 3,
  direction: varsFromServer.textDirection,
  bound: true,
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      perView: 1,
      peek: {
        before: 0,
        after: 35.75
      },
      gap: 16
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24,
      perView: 2,
      peek: {
        before: 0,
        after: 25.75
      }
    }
  }
};

export const setupCardsArticlesBannerAnalytics = (moduleDomNode) => {
  moduleDomNode.querySelector(SELECTORS.MODULE_LINK).addEventListener('click', (e) => {
    trackAnalyticsInteractionByLink(e.target, MODULE_NAME);
  });

  /**
   * Setup analytics for each card/article Ideas and card/article Newsroom item
   */
  moduleDomNode
    .querySelectorAll(`${SELECTORS.CARD_ARTICLE_IDEAS},${SELECTORS.CARD_ARTICLE_NEWSROOM}`)
    .forEach((card, index) => {
      if (card.classList.contains(CARD_ARTICLE_NEWSROOM_CLASS)) {
        setupCardArticleNewsroomAnalytics(card, index);
      } else {
        setupCardArticleIdeasAnalytics(card, index);
      }
    });
};

export const setupCardsArticlesBannerModule = () => {
  try {
    const moduleDomNode = document.querySelector(SELECTORS.MODULE);

    if (!moduleDomNode) {
      return;
    }

    setupWeGlideAtBreakpoints(
      {
        wrapperSelector: SELECTORS.MODULE,
        glideSelector: SELECTORS.SLIDER_TRACK
      },
      WE_GLIDE_OPTIONS
    );

    setupCardsArticlesBannerAnalytics(moduleDomNode);
  } catch (error) {
    logError(`[Shared modules] setupCardsArticlesBannerModule has failed: ${error.message}`, error);
  }
};
